export default {
  title: 'Kazaar Local',
  faviconPath: '/static/icons/favicon.ico',
  defaultCss: 'acuitis.css',
};
